import React from 'react';
import { Divider as Dividr } from 'antd';

/**
 * The antd divider
 *
 * {@link https://ant.design/components/divider#api}
 *
 * @module Divider
 * @param {Object} props - the component props
 * @param {number|boolean} [props.margin] - optional margin prop - pass false to disable or a number to set manually and override the antd `size` prop/default margin
 * @param {Object} [props.style] - optional style object
 * @returns {React.ReactElement} a Divider component
**/
export const Divider = ( { margin, style, ...props } ) => {
    const isVertical = props.type === 'vertical';
    const marginValue = margin === false ? 0 : margin;
    return (
        <Dividr
            { ...props }
            style={ marginValue !== undefined ?
                ( isVertical ?
                    { marginLeft: `${ marginValue }px`, marginRight: `${ marginValue }px`, ...style } :
                    { marginTop: `${ marginValue }px`, marginBottom: `${ marginValue }px`, ...style }
                ) :
                { ...style }
            }
        >
        </Dividr>
    );
};
